import type { Viewport } from '@/lib/viewport';
import { chatColumns } from './chat-format';

/**
 * How the Chat card is laid out (design script: `chatCols`, `threadDisplay`,
 * `sidebarDisplay`):
 * - desktop: list, thread and — when open — the artifact, side by side;
 * - tablet: the list steps aside while an artifact is open;
 * - phone: one column. The list is a ☰ overlay, and an open artifact takes
 *   the thread's place until it is closed.
 */
export interface ChatLayout {
  readonly columns: string;
  /** `overlay`: floated over the thread, closed by a pick, ☰ or Escape. */
  readonly list: 'column' | 'overlay' | 'hidden';
  readonly thread: boolean;
  /** Whether the thread header shows ☰. */
  readonly menu: boolean;
}

export function chatLayout(
  viewport: Viewport,
  artifactOpen: boolean,
  listOpen: boolean,
): ChatLayout {
  if (viewport === 'phone') {
    return {
      columns: 'minmax(0,1fr)',
      list: listOpen ? 'overlay' : 'hidden',
      thread: !artifactOpen,
      menu: true,
    };
  }
  const hideList = artifactOpen && viewport === 'tablet';
  return {
    columns: chatColumns(artifactOpen, hideList),
    list: hideList ? 'hidden' : 'column',
    thread: true,
    menu: hideList,
  };
}
